if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true,
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.product_url = this.getAttribute("data-product-url");
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }
      
      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelectorAll("pickup-availability-drawer");
        if (drawer) {
          drawer.forEach((e) => e.remove());
        }
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        ).outerHTML;
        this.setAttribute("available", "");

        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer"),
        );

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document
              .querySelector("pickup-availability-drawer")
              .show(evt.target);
          });
      }
    },
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);
        this.overlayPage = document.querySelector(
          ".pickup-availability--page-overlay",
        );
        this.mapInjected = false; // ← NEW: track map injection

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      // ─── NEW: Inject Google Map ──────────────────────────────────────
      injectMap() {
        if (this.mapInjected) return;

        const listItem = this.querySelector('.pickup-availability-list__item');
        if (!listItem) return;

        // Responsive map container (16:9)
        const mapContainer = document.createElement('div');
        mapContainer.className = 'pickup-availability-map';
        mapContainer.style.marginTop = '20px';
        mapContainer.style.borderRadius = '8px';
        mapContainer.style.overflow = 'hidden';
        mapContainer.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
        mapContainer.style.backgroundColor = '#f5f5f5';
        mapContainer.style.position = 'relative';
        mapContainer.style.paddingBottom = '56.25%';
        mapContainer.style.height = '0';

        const iframe = document.createElement('iframe');
        iframe.src =
          'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4161.253036267326!2d35.891002276230985!3d32.04642082096296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151c9f31a9c3dac1%3A0x7fa6bcda5d4f3381!2sKinz%20Box%20Mobile!5e1!3m2!1sen!2sjo!4v1783456257697!5m2!1sen!2sjo';
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style.border = '0';
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.setAttribute('aria-label', 'Google Map showing Kinz Box Mobile location');

        mapContainer.appendChild(iframe);

        // Insert after the address block
        const address = listItem.querySelector('.pickup-availability-address');
        if (address) {
          listItem.insertBefore(mapContainer, address.nextSibling);
        } else {
          listItem.appendChild(mapContainer);
        }

        this.mapInjected = true;
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
        this.overlayPage.classList.remove("open");
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);
        this.overlayPage.classList.add("open");

        // ─── NEW: Inject map when drawer opens ───────────────────────
        this.injectMap();
      }
    },
  );
}